import { USAAHome } from './USAAHome';
import { UiFeatureLite } from '@/app/feature';
import { FeatureCodes } from '@ssar-app/domain';

export const USAAFeature: UiFeatureLite = {
  code: FeatureCodes.AscendUSAA,
  rootComponent: <USAAHome />,
};
